var isAppInForeground = function () {
    return true;
};
export { isAppInForeground };
//# sourceMappingURL=AppUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/analytics/lib-esm/utils/AppUtils.js
// module id = null
// module chunks = 